import React from 'react'
import { Box, Button, Copy, Flex, Hide, QR as QRCode } from '@elparking/components'
import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'
import { buildFirebaseUrl } from 'commons/js/util/firebaseUrlBuilder'
import { TRADENAME } from 'commons/js/constants'
const Container = styled(Box)`
    background-size: 150% 250%;
    background-position-y: 30%;
    background-image: url('/images/download-app-background.webp');
    border-radius: 0px 0px 24px 0px;
`

const QRContainer = styled(Box)`
    border-radius: 4px;
`
const DownloadAppBlock = () => {
    const firebaseBaseUrl = buildFirebaseUrl('https://elparking.com')
    return (<>
        <Hide xs sm><Container mt='1em' padding='1em'>
            <Flex flexDirection='column' alignItems='center' justifyContent='center'>
                <Copy textAlign='center' fontColor='white' fontSize='xLarge' fontWeight='bold'>
                    <FormattedMessage defaultMessage='Descarga la App de MutuaMás' />
                </Copy>
                <Copy textAlign='center' fontColor='white' fontSize='medium' fontWeight='regular' mb='1em'>
                    <FormattedMessage defaultMessage='Gestiona tu reserva desde la App y disfruta de todas las ventajas, funcionalidades y descuentos' />
                </Copy>
                <QRContainer backgroundColor='white' width='50%' padding='0.5em'>
                    <QRCode value={firebaseBaseUrl} size='100%'/>
                </QRContainer>
                <Copy fontColor='white' fontSize='medium' fontWeight='regular' mt='1em'>
                    <FormattedMessage defaultMessage='Disponible para iOS y Android' />
                </Copy>
            </Flex>
        </Container>
        </Hide>
        <Hide md lg>
            <Box backgroundColor='accent10' padding='1em' margin='1em 0em'>
                <Copy fontSize='medium' fontWeight='bold' padding='0'>
                    <FormattedMessage defaultMessage='Descarga la App de {tradename}' values={{tradename: TRADENAME}} />
                </Copy>
                <Copy fontSize='small' fontWeight='regular' mb='1em' padding='0'>
                    <FormattedMessage defaultMessage='Gestiona tu reserva desde la App y disfruta de todas las ventajas, funcionalidades y descuentos' />
                </Copy>
                <Button rel='noopener noreferrer' href={firebaseBaseUrl} target='_blank' as='a' width='100%'>
                    <Copy fontColor='white' textAlign='center' padding='0.2em'><FormattedMessage defaultMessage='Descargar app'/></Copy>
                </Button>
            </Box>
        </Hide>
    </>
    )
}

export default DownloadAppBlock
